import Iframe from 'react-iframe';
import { useAuthUser } from '@/hooks';
import styles from './Sentiment.module.css';

export function Sentiment() {
  const user = useAuthUser();

  if (!user.team?.sentiment_app_url) return null;

  return <Iframe url={user.team?.sentiment_app_url} className={styles.contentHub} />;
}
